const burgerContainer = document.querySelector('.burger-container');
const burger = document.querySelector('#navButton');
const nav = document.querySelector('#nav-list');
const body = document.querySelector('body');

burgerContainer.addEventListener('click', () => {
    burger.classList.toggle('active');
    nav.classList.toggle('active');
    body.classList.toggle('nav-opened')
    console.log("burger clicked");
});

const homeButton = document.querySelector('#nav-home');

homeButton.addEventListener('click', () => {
    burger.classList.toggle('active');
    nav.classList.toggle('active');
    body.classList.toggle('nav-opened')
})

// Close Pages by clicking the close button
const closeButtons = document.querySelectorAll('.nav-container-close');

closeButtons.forEach(function(button) {
  button.addEventListener('click', function() {
    const pages = document.querySelectorAll('.page');
    pages.forEach(function(page) {
      page.style.display = 'none';
    });
  });
});

// Open Pages
function openPage(pageId) {
    var page = document.getElementById(pageId);
    if (page) {
        page.style.display = "block";
        burger.classList.remove('active');
        nav.classList.remove('active');
    }
}
window.openPage = openPage

// Open Dropdown Content
function Dropdown() {
    document.getElementById("Dropdown").classList.toggle("show");
    console.log("dropdown clicked");
}
window.Dropdown = Dropdown


//change to page7 aka LITRUM if redirected from portfolio.valentingerhard.com/litrum
window.addEventListener('load', function() {
  if (window.location.hash === '#model2') {
    var page7 = document.getElementById('page7');
    page7.style.display = 'block';
    var model2 = document.getElementById('model2');
    model2.scrollIntoView();
  }

  if (window.location.hash === '#page7') {
    var page7 = document.getElementById('page7');
    page7.style.display = 'block';
  }
});


// Loading Screen
const svg = document.getElementById("loader");
const circle = svg.querySelector("circle");

function resizeCircle() {
  const containerWidth = svg.clientWidth;
  const radius = containerWidth / 2;
  
  circle.setAttribute("cx", radius);
  circle.setAttribute("cy", radius);
  circle.setAttribute("r", radius-10);
}

resizeCircle();
window.addEventListener("resize", resizeCircle);
